import { useState, useMemo, useEffect } from "react";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";

// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from "components/ui/dialog";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "components/ui/table";
import { Card, CardContent } from "components/ui/card";
import {
  MessageSquare,
  Star,
  ChevronDown,
  ChevronUp,
  TrendingUp,
  Search,
  X,
  AlertTriangle,
  Heart,
  Flame,
  Skull,
  UserX,
  Ban,
} from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";

import localization from "../../services/localization";
import { useUserStore } from "context/useUserStore";
import { RiAiGenerateText } from "react-icons/ri";
// import Select from "react-select";
import CustomSelect from "views/Components/CustomSelect";
import SpecificAPI from "../../services/SpecificApi";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const getHealthColor = (score) => {
  if (score <= 0.2) return "bg-green-500";
  if (score <= 0.4) return "bg-yellow-500";
  if (score <= 0.6) return "bg-orange-500";
  return "bg-red-500";
};

// const getOverallHealth = (health) => {
//   const avg =
//     (health?.sexual / 5 +
//       health?.violence / 5 +
//       health?.self_harm / 5 +
//       health?.harassment / 5 +
//       health?.hate / 5) /
//     5;
//   return avg;
// };

const getOverallHealth = (health) => {
  if (!health) return 0;

  const values = [health?.sexual, health?.violence, health?.self_harm, health?.harassment, health?.hate]
    .map(Number)
    .filter((v) => v > 0);

  if (values.length === 0) return 0;

  // const avg = values.reduce((sum, v) => sum + v, 0) / values.length;
  // // Normalize 1–5 → 0–1
  // const normalizedRisk = (avg - 1) / 4;

  const avg = values.reduce((sum, v) => sum + v, 0) / values.length;

  const normalizedRisk = avg / 5;

  console.log("health: ", health, " values: ", values, " avg: ", avg, " normalizedRisk: ", normalizedRisk);

  return normalizedRisk; // 0 to 1
};

export default function ChatRankingModal({
  open,
  onOpenChange,
  onGoToChat,
  messages,
  summaryMessages,
  setSummaryMessages,
  historyId,
}) {
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [theme, setTheme] = useState(localStorage.getItem("SA_user_theme") || "light");
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [summaryResult, setSummaryResult] = useState("");
  const { userData } = useUserStore();

  const sortedSummaries = useMemo(() => {
    return [...summaryMessages]
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .map((item) => ({
        value: item.created_at,
        label: dayjs(item.created_at).local().format("DD/MM/YY HH:mm A"),
        response: item.response,
      }));
  }, [summaryMessages]);

  const [selectedSummary, setSelectedSummary] = useState(sortedSummaries[0] || null);

  const handleSummaryChange = (option) => {
    setSelectedSummary(option);
    setSummaryResult(option.response);
  };

  useEffect(() => {
    if (sortedSummaries.length > 0) {
      setSelectedSummary(sortedSummaries[0]);
      setSummaryResult(sortedSummaries[0].response);
    }
  }, [sortedSummaries]);

  const formatText = (text) => {
    if (!text) return "";
    return text.replace(/\\n/g, "<br/>");
  };

  useEffect(() => {
    if (open) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 800);
      return () => clearTimeout(timer);
    } else {
      setLoading(true);
    }
  }, [open]);

  useEffect(() => {
    console.log("darkMode", theme);
  }, []);

  // useEffect(() => {
  //   if (open) {
  //     setTheme(localStorage.getItem("SA_user_theme") || "dark");
  //   }
  // }, [open]);

  const generateSummary = async () => {
    // const response = await fetch("/api/summarize-chats", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     chats: filteredChats, // or messages if you want all
    //   }),
    // });

    // const data = await response.json();

    // setSummaryResult(data.summary || "No summary returned.");
    setSummaryLoading(true);
    SpecificAPI.getSummaryMessage(userData?.selected_school_id, historyId)
      .then((summaryMessage) => {
        setSummaryMessages((prev) => {
          if (prev.some((msg) => msg.created_at === summaryMessage.created_at)) {
            return prev;
          }
          return [summaryMessage, ...prev];
        });
        setSummaryResult(summaryMessage?.response || "No summary returned.");
        setSummaryLoading(false);
      })
      .catch((error) => {
        const message =
          error?.response?.data?.error || error?.response?.data?.message || error?.message || "Error fetching summary";

        setSummaryResult(message);
        setSummaryLoading(false);
      });
  };

  const handleSummarize = async () => {
    if (summaryMessages.length === 0) {
      try {
        // setSummaryLoading(true);
        // await generateSummary();
        setSummaryOpen(true);
      } catch (error) {
        console.error(error);
        setSummaryResult("Something went wrong while generating summary.");
        setSummaryOpen(true);
      } finally {
        setSummaryLoading(false);
      }
    } else {
      setSummaryOpen(true);
    }
  };

  const getAverageRating = (ratingObj) => {
    if (!ratingObj || typeof ratingObj !== "object") return 0;

    const values = Object.values(ratingObj).filter((v) => typeof v === "number");

    if (values.length === 0) return 0;

    return values.reduce((sum, v) => sum + v, 0) / values.length;
  };

  const allTags = useMemo(() => {
    const tags = new Set();
    messages?.forEach((chat) => {
      if (Array.isArray(chat?.prompt_health?.tags)) {
        chat?.prompt_health?.tags?.forEach((tag) => tags.add(tag));
      }
    });
    return Array.from(tags).sort();
  }, [messages]);

  const filteredChats = useMemo(() => {
    let filtered = messages || [];
    console.log("msg", messages);

    if (searchQuery) {
      filtered = filtered.filter(
        (chat) =>
          chat.question?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          chat.response?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          chat.user?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    if (selectedTags.length > 0) {
      filtered = filtered.filter((chat) => selectedTags.some((tag) => chat?.prompt_health?.tags.includes(tag)));
    }

    return filtered.sort(
      (a, b) => getAverageRating(b.prompt_health?.rating) - getAverageRating(a.prompt_health?.rating),
    );
  }, [messages, searchQuery, selectedTags]);

  const topThree = filteredChats.slice(0, 3);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleGoToChat = (id) => {
    onOpenChange(false);
    onGoToChat(id);
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) => (prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]));
  };

  // Determine theme classes
  const themeClasses = theme === "dark" ? "dark bg-gray-900 text-gray-100" : "bg-white text-gray-900";

  const modalClasses =
    theme === "dark" ? "dark bg-gray-800 text-gray-100 addEditModal" : "bg-gray-50 text-gray-900 addEditModal";

  // console.log(messages);

  return (
    <div>
      {/* <Dialog open={open} onOpenChange={onOpenChange} className={"addEditModal"}> */}
      <Modal
        show={open}
        onHide={() => onOpenChange(false)}
        centered
        size="xl"
        contentClassName={modalClasses}
        data-bs-theme={theme === "dark" ? "dark" : "light"}
      >
        <Modal.Body>
          {/* <DialogContent
          // Important: Setting max-height and removing default padding (px-0 py-0)
          className={`addEditModal w-[85vw] max-w-[85vw] sm:max-w-[85vw] max-h-[85vh] overflow-hidden shadow-lg rounded-lg transition-colors duration-300 px-0 py-0 ${modalClasses}`}
        > */}
          {loading ? (
            <div className="flex justify-center items-center h-[70vh]">
              <ClipLoader size={50} color="var(--primary-icon)" />
            </div>
          ) : (
            // Flex Container to hold fixed header/filters and scrollable body
            <div className="flex flex-col h-full">
              {/* FIXED Header */}
              {/* <DialogHeader className="px-6 pt-6 pb-2 flex-shrink-0">
                <DialogTitle className="text-2xl font-bold flex items-center gap-2">
                  <TrendingUp className="h-6 w-6" />
                  {localization.chatRankings || "Chat Rankings"}
                </DialogTitle>
              </DialogHeader> */}

              {/* <Modal.Header closeButton className={theme==="dark" ? "bg-gray-800 text-gray-100" : ""}>
                <Modal.Title>
                  {localization.chatRankings || "Chat Rankings"}
                </Modal.Title>
              </Modal.Header> */}

              <Modal.Header
                className={`d-flex justify-content-between align-items-center ${
                  theme === "dark" ? "bg-gray-800 text-gray-100" : ""
                }`}
              >
                <Modal.Title>{localization.chatRankings || "Chat Rankings"}</Modal.Title>

                <div className="flex items-center gap-2">
                  <Button size="sm" onClick={handleSummarize} disabled={summaryLoading} className="gap-2">
                    {summaryLoading ? (
                      <ClipLoader size={14} color="white" />
                    ) : (
                      <>
                        <TrendingUp className="h-4 w-4" />
                        {localization.summarizeWithAI || "Summarize with AI"}
                      </>
                    )}
                  </Button>

                  <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
                    ✕
                  </Button>
                </div>
              </Modal.Header>

              {/* FIXED Content (Search and Filters) */}
              <div className="space-y-4 px-6 pb-4 pt-4 border-b flex-shrink-0">
                <div className="relative w-full">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                  <Input
                    placeholder={localization.searchPlaceholder || "Search chats by question, answer, or user..."}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={`
                      !pl-10 !pr-10 w-full
                      ${
                        theme === "dark"
                          ? "bg-gray-800 text-gray-100 placeholder-gray-400 border-gray-700 focus:border-blue-500 focus:ring-blue-500"
                          : "bg-white text-gray-900 placeholder-gray-500 border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      }
                    `}
                  />
                  {searchQuery && (
                    <Button
                      variant="ghost"
                      size="sm"
                      className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 p-0"
                      onClick={() => setSearchQuery("")}
                    >
                      <X className="h-4 w-4" />
                    </Button>
                  )}
                </div>

                {/* Tag Filter */}
                <div className="space-y-2">
                  <p className="text-sm font-medium text-muted-foreground">
                    {localization.filterByTags || "Filter by tags:"}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {allTags.map((tag) => (
                      <Badge
                        key={tag}
                        variant={selectedTags.includes(tag) ? "default" : "outline"}
                        className="cursor-pointer transition-all hover:scale-105"
                        onClick={() => toggleTag(tag)}
                      >
                        {tag}
                        {selectedTags.includes(tag) && <X className="ml-1 h-3 w-3" />}
                      </Badge>
                    ))}
                  </div>
                  {selectedTags.length > 0 && (
                    <Button variant="ghost" size="sm" onClick={() => setSelectedTags([])} className="h-8 text-xs">
                      {localization.clearFilters || "Clear all filters"}
                    </Button>
                  )}
                </div>
              </div>

              {/* SCROLLABLE CONTENT BODY (Handles Vertical Scroll) */}
              <div
                className="flex-grow overflow-y-auto space-y-6 pt-4 pb-6"
                // The max-h is now the responsibility of the flex-grow parent, but added a calc for safety
                // in case flex-grow isn't perfect in all environments.
                style={{ maxHeight: "calc(85vh - 170px)" }}
              >
                {/* Top 3 Cards Container */}
                <div className="space-y-4">
                  {/* Title with Padding */}
                  <h3 className="text-lg font-semibold mb-4 text-foreground px-6">
                    {localization.topChats || "Top 3 Highest Rated Chats"}
                  </h3>

                  {/* HORIZONTAL SCROLL Wrapper for Cards */}
                  <div className="overflow-x-auto w-full pb-2">
                    {/* Inner content which is wider than the container, forcing scroll */}
                    <div className="flex gap-4 flex-nowrap min-w-[700px] px-6">
                      {topThree.map((chat, index) => (
                        <Card
                          key={chat.id}
                          className={`flex-shrink-0 w-[300px] relative overflow-hidden border-2 hover:border-primary transition-all hover:shadow-lg animate-in fade-in slide-in-from-bottom-4 duration-500 ${themeClasses}`}
                          style={{ animationDelay: `${index * 100}ms` }}
                        >
                          <div className="absolute top-2 right-2">
                            <Badge variant={index === 0 ? "default" : "success"} className="text-xs">
                              #{index + 1}
                            </Badge>
                          </div>
                          <CardContent className="pt-6 space-y-3">
                            <div className="flex items-center gap-2">
                              <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                              <span className="text-2xl font-bold">
                                {/* {chat.prompt_health?.rating} */}
                                {getAverageRating(chat.prompt_health?.rating).toFixed(1)}
                              </span>
                            </div>
                            <p className="text-sm font-medium text-foreground line-clamp-2">
                              {chat.question || "Prompt Request"}
                            </p>
                            <div className="flex flex-wrap gap-1">
                              {chat?.prompt_health?.tags?.map((tag) => (
                                <Badge key={tag} variant="success" className="text-xs">
                                  {tag}
                                </Badge>
                              ))}
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                    </div>
                  </div>
                </div>

                {/* All Chats Table Container */}
                <div className="space-y-4">
                  {/* Title with Padding */}
                  <h3 className="text-lg font-semibold mb-4 text-foreground px-6">
                    {localization.allChats || "All Chats by Rating"} ({filteredChats.length})
                  </h3>

                  {filteredChats.length === 0 ? (
                    <div className="text-center py-12 text-muted-foreground px-6">
                      <AlertTriangle className="h-12 w-12 mx-auto mb-3 opacity-50" />
                      <p>{localization.noChatsFound || "No chats found matching your filters."}</p>
                    </div>
                  ) : (
                    <div className="border-t">
                      {/* HORIZONTAL SCROLL Wrapper for Table */}
                      <div className="overflow-x-auto">
                        <Table className="min-w-[850px]">
                          <TableHeader>
                            <TableRow>
                              {/* Apply padding to the first and last columns only */}
                              <TableHead className="w-[50px] px-6">{localization.rating || "Rating"}</TableHead>
                              <TableHead className="w-[100px]">{localization.user || "User"}</TableHead>
                              <TableHead>{localization.question || "Question"}</TableHead>
                              <TableHead className="w-[200px]">{localization.tags || "Tags"}</TableHead>
                              <TableHead className="w-[120px]">{localization.health || "Health"}</TableHead>
                              <TableHead className="w-[120px] text-center pr-6">
                                {localization.actions || "Actions"}
                              </TableHead>
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {filteredChats.map((chat, index) => (
                              <>
                                <TableRow
                                  key={chat.id}
                                  className="cursor-pointer hover:bg-muted/50 transition-colors"
                                  onClick={() => toggleExpand(chat.id)}
                                >
                                  {/* <TableCell className="px-6">
                                    <div className="flex items-center gap-1">
                                      <Badge variant="outline">
                                        #{index + 1}
                                      </Badge>
                                      <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                                      <span className="font-semibold">
                                        {chat.prompt_health?.rating}
                                      </span>
                                    </div>
                                  </TableCell> */}
                                  <TableCell className="px-6">
                                    <TooltipProvider>
                                      <Tooltip>
                                        <TooltipTrigger asChild>
                                          <div className="flex items-center gap-1 cursor-help">
                                            <Badge variant="outline">#{index + 1}</Badge>
                                            <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                                            <span className="font-semibold">
                                              {getAverageRating(chat.prompt_health?.rating).toFixed(1)}
                                            </span>
                                          </div>
                                        </TooltipTrigger>

                                        <TooltipContent side="right" className={"p-3 " + themeClasses}>
                                          <div className="space-y-2 text-xs min-w-[220px]">
                                            <p className="font-semibold">
                                              {localization.ratingBreakdown || "Rating Breakdown:"}
                                            </p>

                                            <div className="space-y-1">
                                              {Object.entries(chat.prompt_health?.rating || {}).map(([key, value]) => (
                                                <div key={key} className="flex items-center justify-between gap-4">
                                                  <span>{key}</span>
                                                  <span className="font-mono">{value}/5</span>
                                                </div>
                                              ))}
                                            </div>

                                            <div className="border-t pt-2 flex justify-between font-semibold">
                                              <span>Average</span>
                                              <span>{getAverageRating(chat.prompt_health?.rating).toFixed(2)}</span>
                                            </div>
                                          </div>
                                        </TooltipContent>
                                      </Tooltip>
                                    </TooltipProvider>
                                  </TableCell>
                                  <TableCell>
                                    <span className="text-sm text-muted-foreground">{chat?.user?.name}</span>
                                  </TableCell>
                                  <TableCell>
                                    <div className="flex items-center justify-between gap-2">
                                      <span className="text-sm">{chat.question || "Prompt Request"}</span>
                                      {expandedId === chat.id ? (
                                        <ChevronUp className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                                      ) : (
                                        <ChevronDown className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                                      )}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <div className="flex flex-wrap gap-1">
                                      {chat.prompt_health?.tags?.map((tag) => (
                                        <Badge key={tag} variant="success" className="text-xs">
                                          {tag}
                                        </Badge>
                                      ))}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <TooltipProvider>
                                      <Tooltip>
                                        <TooltipTrigger asChild>
                                          <div className="flex items-center gap-2 cursor-help">
                                            <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                                              <div
                                                className={`h-full transition-all ${getHealthColor(
                                                  getOverallHealth(chat.prompt_health?.policy_risk),
                                                )}`}
                                                style={{
                                                  width: `${
                                                    (1 - getOverallHealth(chat.prompt_health?.policy_risk)) * 100
                                                  }%`,
                                                }}
                                              />
                                            </div>
                                            <span className="text-xs font-mono">
                                              {((1 - getOverallHealth(chat.prompt_health?.policy_risk)) * 100).toFixed(
                                                0,
                                              )}
                                              %
                                            </span>
                                          </div>
                                        </TooltipTrigger>
                                        <TooltipContent side="left" className={"p-3 " + themeClasses}>
                                          <div className="space-y-2 text-xs">
                                            <p className="font-semibold">
                                              {localization.promptHealthDetails || "Prompt Health Details:"}
                                            </p>
                                            <div className="space-y-1">
                                              <div className="flex items-center justify-between gap-4">
                                                <span className="flex items-center gap-1">
                                                  <Heart className="h-3 w-3" /> {localization.sexual || "Sexual"}
                                                </span>
                                                <span className="font-mono">
                                                  {((chat.prompt_health?.policy_risk?.sexual / 5) * 100).toFixed(0)}%
                                                </span>
                                              </div>
                                              <div className="flex items-center justify-between gap-4">
                                                <span className="flex items-center gap-1">
                                                  <Flame className="h-3 w-3" /> {localization.violence || "Violence"}
                                                </span>
                                                <span className="font-mono">
                                                  {((chat.prompt_health?.policy_risk?.violence / 5) * 100).toFixed(0)}%
                                                </span>
                                              </div>
                                              <div className="flex items-center justify-between gap-4">
                                                <span className="flex items-center gap-1">
                                                  <Skull className="h-3 w-3" /> {localization.selfHarm || "Self Harm"}
                                                </span>
                                                <span className="font-mono">
                                                  {((chat.prompt_health?.policy_risk?.self_harm / 5) * 100).toFixed(0)}%
                                                </span>
                                              </div>
                                              <div className="flex items-center justify-between gap-4">
                                                <span className="flex items-center gap-1">
                                                  <UserX className="h-3 w-3" />{" "}
                                                  {localization.harassment || "Harassment"}
                                                </span>
                                                <span className="font-mono">
                                                  {((chat.prompt_health?.policy_risk?.harassment / 5) * 100).toFixed(0)}
                                                  %
                                                </span>
                                              </div>
                                              <div className="flex items-center justify-between gap-4">
                                                <span className="flex items-center gap-1">
                                                  <Ban className="h-3 w-3" /> {localization.hate || "Hate"}
                                                </span>
                                                <span className="font-mono">
                                                  {((chat.prompt_health?.policy_risk?.hate / 5) * 100).toFixed(0)}%
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </TooltipContent>
                                      </Tooltip>
                                    </TooltipProvider>
                                  </TableCell>
                                  <TableCell className="text-center pr-6">
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleGoToChat(chat.id);
                                      }}
                                      className="gap-1 hover:bg-primary/10"
                                    >
                                      <MessageSquare className="h-4 w-4" />
                                      {localization.goToChat || "Go to Chat"}
                                    </Button>
                                  </TableCell>
                                </TableRow>
                                {expandedId === chat.id && (
                                  <TableRow
                                    key={`${chat.id}-answer`}
                                    className="animate-in fade-in slide-in-from-top-2 duration-300"
                                  >
                                    <TableCell colSpan={7} className="bg-muted/30 px-6">
                                      <div className="py-3 px-4">
                                        <p className="text-sm font-semibold text-foreground mb-2">
                                          {localization.response || "Response:"}
                                        </p>
                                        <p className="text-sm text-muted-foreground leading-relaxed">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: chat.response
                                                ?.replace(/\\n\\njson/g, "")
                                                .replace(/\n\njson/g, ""),
                                            }}
                                          />
                                        </p>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* </DialogContent>
      </Dialog> */}
        </Modal.Body>
      </Modal>

      <Modal
        show={summaryOpen}
        onHide={() => setSummaryOpen(false)}
        centered
        size="xl"
        style={{ minHeight: "90vh" }}
        contentClassName={modalClasses}
        backdropClassName="custom-backdrop"
      >
        {/* <Modal.Header
          closeButton
          className={`d-flex justify-content-between align-items-center ${
            theme === "dark" ? "bg-gray-800 text-gray-100" : ""
          }`}
        >
          <Modal.Title>{localization.aiSummary || "AI Summary"}</Modal.Title>
        </Modal.Header> */}

        <Modal.Body style={{ minHeight: "90vh", gap: "1.5rem" }} className="flex flex-col">
          <Modal.Header
            className={`d-flex justify-content-between align-items-center ${
              theme === "dark" ? "bg-gray-800 text-gray-100" : ""
            }`}
          >
            <Modal.Title>{localization.aiSummary || "AI Summary"}</Modal.Title>

            <div className="flex items-center gap-2">
              <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
                ✕
              </Button>
            </div>
          </Modal.Header>
          <div className="flex items-center gap-2">
            <div className="min-w-[220px]">
              <CustomSelect
                options={sortedSummaries}
                value={selectedSummary}
                onChange={handleSummaryChange}
                placeholder="Select summary"
                isSearchable={false}
              />
            </div>
            <Button size="sm" onClick={generateSummary} disabled={summaryLoading} className="gap-2">
              {summaryLoading ? (
                <ClipLoader size={14} color="white" />
              ) : (
                <>
                  <RiAiGenerateText className="h-4 w-4" />
                  {localization.generateNewSummary || "Generate New Summary"}
                </>
              )}
            </Button>
          </div>
          {summaryLoading ? (
            <div className="flex justify-center items-center h-[70vh]">
              <ClipLoader size={50} color="var(--primary-icon)" />
            </div>
          ) : (
            <div className="flex flex-col mt-4 gap-4">
              <div
                dangerouslySetInnerHTML={{
                  __html: formatText(summaryResult || "No Summary Available"),
                }}
              />
              {/* <div className="whitespace-pre-wrap text-sm leading-relaxed">
                {summaryResult || "No Summary Available"}
              </div> */}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
